import * as React from 'react';

function SvgGooglePlusColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.996 2C7.82 2 2 7.818 2 14.994 2 22.172 7.82 27.99 14.996 27.99c7.177 0 12.996-5.818 12.996-12.996C27.992 7.818 22.172 2 14.996 2z"
        fill="#DB4639"
      />
      <mask
        id="GooglePlusColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={26}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.996 2C7.82 2 2 7.818 2 14.994 2 22.172 7.82 27.99 14.996 27.99c7.177 0 12.996-5.818 12.996-12.996C27.992 7.818 22.172 2 14.996 2z"
          fill="#fff"
        />
      </mask>
      <g
        mask="url(#GooglePlusColour_svg__a)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      >
        <path d="M20.935 17.494h1.742v-5.206h-1.742v5.206z" />
        <path d="M19.204 15.762h5.206V14.02h-5.206v1.742zM17.259 14.066h-5.806v2.074h3.478c-.503 1.486-1.89 2.553-3.522 2.553-2.057 0-3.724-1.695-3.724-3.786 0-2.09 1.667-3.784 3.724-3.784.901 0 1.725.326 2.37.867h.097l1.532-1.557a5.88 5.88 0 00-3.999-1.567c-3.285 0-5.948 2.706-5.948 6.041 0 3.34 2.663 6.043 5.948 6.043a5.876 5.876 0 003.623-1.25 6.075 6.075 0 002.122-3.222c.14-.533.105-1.07.105-1.62v-.792z" />
      </g>
    </svg>
  );
}

export default SvgGooglePlusColour;
